<script>
import { mapGetters } from 'vuex';
import BaseSettingsHeader from '../../settings/components/BaseSettingsHeader.vue';

export default {
  components: {
    BaseSettingsHeader,
  },
  data() {
    return {
      stats: [
        {
          title: 'Total Invoice',
          value: '1,240',
          change: '+12%',
          trend: 'up',
          icon: 'i-lucide-receipt',
          color: 'text-n-blue-9',
          bg: 'bg-n-blue-2',
        },
        {
          title: 'SPK Aktif',
          value: '84',
          change: '+5%',
          trend: 'up',
          icon: 'i-lucide-file-cog',
          color: 'text-n-iris-9',
          bg: 'bg-n-iris-2',
        },
        {
          title: 'Produk Terjual',
          value: '3,850',
          change: '-2%',
          trend: 'down',
          icon: 'i-lucide-package',
          color: 'text-n-green-9',
          bg: 'bg-n-green-2',
        },
      ],
      recentActivities: [
        {
          id: 1,
          action: 'Invoice INV-2023-001 Diterbitkan',
          time: '2 jam yang lalu',
          icon: 'i-lucide-file-text',
        },
        {
          id: 2,
          action: 'SPK-1094 Selesai Dikerjakan',
          time: '5 jam yang lalu',
          icon: 'i-lucide-check-circle',
        },
        {
          id: 3,
          action: 'Stok Produk "Kertas A4" Menipis',
          time: '1 hari yang lalu',
          icon: 'i-lucide-alert-triangle',
        },
      ],
    };
  },
};
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-auto bg-n-surface-1 p-8">
    <div class="flex flex-col w-full max-w-5xl mx-auto space-y-8">
      <BaseSettingsHeader
        title="Dashboard Cetakers Flow"
        description="Ringkasan aktivitas dan metrik dari integrasi Anda"
        icon="i-lucide-layout-dashboard"
      />

      <!-- Stats Grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          v-for="stat in stats"
          :key="stat.title"
          class="flex flex-col p-6 bg-n-alpha-1 border border-n-weak/50 rounded-2xl shadow-sm transition-all hover:shadow-md"
        >
          <div class="flex justify-between items-center mb-4">
            <span class="text-n-slate-11 text-sm font-medium">{{ stat.title }}</span>
            <div :class="`p-2 rounded-lg ${stat.bg}`">
              <Icon :icon="stat.icon" :class="`size-5 ${stat.color}`" />
            </div>
          </div>
          <div class="flex items-baseline gap-2">
            <span class="text-3xl font-bold text-n-slate-12">{{ stat.value }}</span>
            <span
              :class="[
                'text-xs font-semibold px-2 py-0.5 rounded-full',
                stat.trend === 'up' ? 'text-n-green-11 bg-n-green-2' : 'text-n-red-11 bg-n-red-2',
              ]"
            >
              {{ stat.change }}
            </span>
          </div>
        </div>
      </div>

      <!-- Recent Activity -->
      <div class="flex flex-col bg-n-alpha-1 border border-n-weak/50 rounded-2xl shadow-sm overflow-hidden">
        <div class="px-6 py-4 border-b border-n-weak/50 bg-n-alpha-1/50">
          <h3 class="font-semibold text-n-slate-12">Aktivitas Terkini</h3>
        </div>
        <div class="p-6">
          <ul class="space-y-4">
            <li
              v-for="activity in recentActivities"
              :key="activity.id"
              class="flex items-center gap-4"
            >
              <div class="p-2 rounded-full bg-n-slate-2">
                <Icon :icon="activity.icon" class="size-4 text-n-slate-11" />
              </div>
              <div class="flex flex-col">
                <span class="text-n-slate-12 text-sm font-medium">{{ activity.action }}</span>
                <span class="text-n-slate-10 text-xs">{{ activity.time }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>
